<template>
<div class="nj-input-text">
    <div class="nj-label">{{ label }}</div>
    <div class="nj-flex">
        <input :type="type" class="nj-text" :value="value" :placeholder="placeholder" @input="input($event)" @keyup.enter="enter()" :disabled="disabled" :autofocus="focus" />
        <slot></slot>
    </div>
</div>
</template>
<script>
export default {
    name: "InputText",
    props: {
        value: null,
        id: {
            type: String,
            default: "",
        },
        type: {
            type: String,
            default: "text"
        },
        label: {
            type: String,
            default: "",
        },
        placeholder: {
            type: String,
            default: "",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        focus: {
            type: Boolean,
            default: false,
        }
    },
    methods: {
        input(event) {
            this.$emit("input", event.target.value == "" ? null : event.target.value)
        },
        enter() {
            this.$emit("enter")
        },
    },
    mounted() {

    },
}
</script>

<style scoped>
.nj-input-text {
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    gap: 0;
    margin: 0 0 6px 0;
}

.nj-text:disabled {
    background-color: var(--bg-disabled);
}
</style>